import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pn-spinner',
  templateUrl: './pn-spinner.component.html',
  styleUrls: ['./pn-spinner.component.scss'],
})
export class PnSpinnerComponent implements OnInit {
  ngOnInit() {}
}
